module.exports = __webpack_public_path__ + "static/media/BB.8426500d.svg";